import withRoot from "./modules/withRoot";
// --- Post bootstrap -----
import React, { useEffect } from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import Typography from "./modules/components/Typography";
import HowItWorks from "./modules/views/HowItWorks";
import InstallFeatures from "./modules/views/InstallFeatures";
import InstallSecurity from "./modules/views/InstallSecurity";
import WorkspaceAdminNotice from "./modules/views/WorkspaceAdminNotice";
import AppFooter from "./modules/views/AppFooter";
import ReactGA from "react-ga";

const TRACKING_ID = "UA-211546357-1";
ReactGA.initialize(TRACKING_ID);

function Install() {
  useEffect(() => {
    ReactGA.event({
      category: "Page Load",
      action: "Install Page",
    });
  }, []);

  return (
    <React.Fragment>
      <Container>
        <Box mt={8} mb={6}>
          <Typography variant="h4" marked="center" align="center" gutterBottom>
            What Dubslack Does
          </Typography>
          <Typography variant="body1" align="center">
            Dubslack is a smartphone app for iOS and Android that lets you
            manage your Slack status from one place. Many people belong to
            multiple Slack workspaces, and without Dubslack you'd have to
            update your status manually in each one. Dubslack connects to
            your workspaces through Dubstatus, the Slack app that grants it
            permission to read and update your status, and then automatically
            synchronizes your status across every connected workspace.
          </Typography>
        </Box>
      </Container>

      <HowItWorks />

      <Container>
        <Box mt={8} mb={8}>
          <Typography variant="h4" marked="center" align="center" gutterBottom>
            Inside Slack
          </Typography>
          <Typography variant="body1" align="center">
            When you tap Add Account, Slack shows its standard authorization
            screen for the app named "Dubstatus". Approve it to
            grant Dubslack permission to read and update your status. Once
            approved, your Slack status updates automatically every time you
            change it in the Dubslack app.
          </Typography>
        </Box>
      </Container>

      <InstallFeatures />
      <InstallSecurity />
      <WorkspaceAdminNotice />

      <Container>
        <Box mt={8} mb={10}>
          <Typography variant="body1" align="center">
            See the{" "}
            <Link component={RouterLink} to="/support" underline="always">
              Support page
            </Link>{" "}
            for common issues and FAQs.
          </Typography>
        </Box>
      </Container>

      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Install);
